import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import tippy, { Instance, Props } from "tippy.js";

@ModuleName("UtilityInit")
export class UtilityInit implements AxInit {
    AxInit(init: UtilityInitData): void {
        tippy('.wtp-input__hint-btn',
        {
            content: `<img src="${init.wtpImageSamplePath}">`,
            allowHTML: true,
            placement: 'bottom',
        });
    }
}

interface UtilityInitData {
    wtpImageSamplePath: string;
}